var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphonesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 73.6667V52C91 30.4609 73.5391 13 52 13C30.4609 13 13 30.4609 13 52V73.6667",
    stroke: "#EAEAEA",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3335 64.8169C69.3335 62.6032 69.3335 61.4963 69.5876 60.6172C70.175 58.5844 71.709 57.0426 73.6184 56.5656C79.1324 55.188 80.2494 60.3132 84.2051 61.9044C84.3048 61.9445 84.4047 61.9856 84.5046 62.0276C88.8035 63.8335 90.9937 68.4334 90.9827 73.0962L90.9791 74.6393C90.9695 78.7585 88.7765 82.593 85.1179 84.4859C81.0521 86.5894 79.696 92.078 73.7875 90.8125C71.8946 90.407 70.3336 88.9563 69.6702 86.9859C69.3335 85.9859 69.3335 84.6789 69.3335 82.0648V64.8169Z",
    stroke: "#EAEAEA",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6669 82.5157C34.6669 84.7295 34.6669 85.8364 34.4128 86.7155C33.8253 88.7483 32.2914 90.2901 30.382 90.7671C24.868 92.1446 23.7509 87.0195 19.7953 85.4283C19.706 85.3924 19.6166 85.3557 19.5272 85.3183C15.2017 83.5091 13.0067 78.9019 13.0176 74.2384L13.0213 72.661C13.0309 68.5601 15.222 64.7407 18.8825 62.8468C22.9482 60.7433 24.3044 55.2546 30.2129 56.5202C32.1058 56.9257 33.6667 58.3764 34.3302 60.3468C34.6669 61.3468 34.6669 62.6538 34.6669 65.2679V82.5157Z",
    stroke: "#EAEAEA",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesIcon);
export default __webpack_public_path__ + "static/media/headphones-icon.b1d50305df8aa4ee6997af3c63dbc716.svg";
export { ForwardRef as ReactComponent };